import { heartbeat } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import { send } from '../../lib/send';

export function find({ url: { service: baseURL }, token }: IAPI) {
  return async function find(
    params: heartbeat.FindInput
  ): Promise<heartbeat.FindResult> {
    const url = new URL(`/heartbeat`, baseURL);
    for (const [key, value] of Object.entries(params)) {
      url.searchParams.set(key, value);
    }
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch {
      throw new Error('Failed to fetch heartbeats');
    }
  };
}

export function getHeartbeat({ url: { service: baseURL }, token }: IAPI) {
  return ({
    user,
    country,
  }: {
    user: string;
    country: string;
  }): Promise<heartbeat.HeartbeatResult> =>
    send({
      baseURL,
      token,
      path: `/heartbeat/${country}/${user}`,
      method: 'GET',
    });
}

export function deleteHeartbeat({ url: { service: baseURL }, token }: IAPI) {
  return async function deleteHeartbeat(
    user: string,
    country: string
  ): Promise<void> {
    const url = new URL(`/heartbeat/${country}/${user}`, baseURL);
    try {
      const response = await fetch(url, {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          Authorization: token,
        },
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
    } catch {
      throw new Error('Failed to delete heartbeat');
    }
  };
}

export function sendHeartbeat({ url: { service: baseURL }, token }: IAPI) {
  return async function sendHeartbeat(
    user: string,
    country: string
  ): Promise<heartbeat.HeartbeatResult> {
    const url = new URL(`/heartbeat/${country}/${user}`, baseURL);
    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: token,
      },
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  };
}
